import auth from '@react-native-firebase/auth';
import { ActivityType } from 'fitbeat.gym-core';
import { CardioOrResistance, IHeartRate } from 'fitbeat.models';
import React, { Component } from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { connect } from 'react-redux';
import { getConfig } from '../../config';
import ConnectedWorkoutApp from '../../ConnectedApps/connected-workout-app';
import { superfluousConnectedAppHeartRateData } from '../../HomeWorkouts';
import theme from '../../theme';
import { defaultScale } from '../../utils/scaling';

interface IState {
  heartRateData: number | null;
}
interface IProps {
  connectedApp: ConnectedWorkoutApp;
}

interface IMapDispatchProps {
  updateHeartRate: (hrData: IHeartRate) => void;
}

class WorkoutActionsTest extends Component<IProps & IMapDispatchProps, IState> {
  constructor(props) {
    super(props);
    this.state = {
      heartRateData: null,
    };
  }

  public render() {
    const { heartRateData } = this.state;
    const { connectedApp } = this.props;

    return (
      <View style={styles.connectedItemsContainer}>
        <Text style={[theme.textStyle.heading2, styles.connectedItemsHeading]}>
          Only visible to alpha iOS users
        </Text>
        <View style={styles.workoutPairActionsContainer}>
          <TouchableOpacity
            onPress={async () =>
              await connectedApp.prepareHomeWorkout({
                userId: 'test',
                activityType: ActivityType.BalanceFitillion,
              })
            }
          >
            <Text style={styles.workoutActionButtonContainer}>Prepare</Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={async () =>
              await connectedApp.registerHREventHandler(
                (heartRate: number) => {
                  this.setState({ heartRateData: heartRate });
                },
              )
            }
          >
            <Text style={styles.workoutActionButtonContainer}>
              {heartRateData}
              Register HR
            </Text>
          </TouchableOpacity>
        </View>
        <View style={styles.workoutPairActionsContainer}>
          <TouchableOpacity
            onPress={async () => await connectedApp.startWorkout()}
          >
            <Text style={styles.workoutActionButtonContainer}>Start</Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={async () => await connectedApp.pauseWorkout()}
          >
            <Text style={styles.workoutActionButtonContainer}>pause</Text>
          </TouchableOpacity>
        </View>
        <View style={styles.workoutPairActionsContainer}>
          <TouchableOpacity
            onPress={async () => await connectedApp.resumeWorkout()}
          >
            <Text style={styles.workoutActionButtonContainer}>Resume</Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={async () => await connectedApp.stopAndDiscardWorkout()}>
            <Text style={styles.workoutActionButtonContainer}>Stop and Discard workout</Text>
          </TouchableOpacity>
        </View>

        <View style={styles.workoutPairActionsContainer}>
          <TouchableOpacity onPress={
            async () => await connectedApp.stopAndSaveWorkout(
              {
                uniqueReference: `test-${Date.now()}`,
                startTimeOfFirstExercise: new Date(Date.now() - (10 * 60000)),
                endTime: new Date(),
                settings: {
                  cardioOrResistance: CardioOrResistance.Balance,
                  activityType: ActivityType.BalanceFitillion,
                },
              },
            )}>
            <Text style={styles.workoutActionButtonContainer}>Stop and Save workout</Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={async () => connectedApp.debugTestIntegration()}>
            <Text style={styles.workoutActionButtonContainer}>Debug: test integration</Text>
          </TouchableOpacity>
        </View>

        <View style={styles.workoutPairActionsContainer}>
          <TouchableOpacity onPress={this.checkInStudioAndStartHRListener}>
            <Text style={styles.workoutActionButtonContainer}>Checkin Studio Workout</Text>
          </TouchableOpacity>
        </View>
      </View>
    );
  }

  private checkInStudioAndStartHRListener = async () => {
    const { connectedApp, updateHeartRate } = this.props;
    await connectedApp.prepareStudioWorkout({
      userId: auth().currentUser.uid,
      activityType: ActivityType.BalanceFitillion,
      hrMetricsServerBaseUrl: getConfig().hrMetricsServer,
      isoStartTimeOfWarmup: new Date(new Date().getTime() + 60000).toISOString(), // one min in future
      isoEndTime: new Date(new Date().getTime() + 2 * 60000).toISOString(), // two min in future
      startingZone: '12',
    });
    const mappedListener = (heartRate: number) => {
      updateHeartRate({
        heartRate,
        timestamp: new Date(),
        source: connectedApp.name,
        debug: `ConnectedApp:${connectedApp.name}`,
      });
    };
    const unRegister = connectedApp.registerHREventHandler(mappedListener);
    const twoMinutesInMs = 60000 * 2;
    setTimeout(unRegister, twoMinutesInMs);
  }
}

const mapDispatchToProps = (dispatch): IMapDispatchProps => ({
  updateHeartRate: (heartRateData: IHeartRate) => dispatch(superfluousConnectedAppHeartRateData(heartRateData)),
});

const styles = StyleSheet.create({
  connectedItemsContainer: {
    flexDirection: 'column',
    justifyContent: 'center',
    paddingBottom: defaultScale(0),
    backgroundColor: theme.WHITE,
    marginBottom: defaultScale(10),
  },
  connectedItemsHeading: {
    marginBottom: defaultScale(8),
  },
  workoutActionButtonContainer: {
    ...theme.textStyle.bodyCopyBold,
    textAlign: 'center',
    color: theme.PRIMARY,
    paddingVertical: defaultScale(10),
  },
  workoutPairActionsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});

export default connect(null, mapDispatchToProps)(WorkoutActionsTest);
